import { apiRequest } from "@/lib/api";

export type PublicPlatformSettings = {
  platform_name: string;
  support_email: string;
  support_whatsapp: string;
  support_hours: string;
  whatsapp_message: string;
};

const FALLBACK_SETTINGS: PublicPlatformSettings = {
  platform_name: "Fornecedor.net",
  support_email: "suporte@fornecedor.net",
  support_whatsapp: "",
  support_hours:
    "Segunda a sexta-feira, em horário comercial, exceto feriados.",
  whatsapp_message:
    "Olá! Estou com uma dúvida sobre o Fornecedor.net.",
};

export function getPublicPlatformSettingsFallback():
  PublicPlatformSettings {
  return FALLBACK_SETTINGS;
}

export async function getPublicPlatformSettings():
  Promise<PublicPlatformSettings> {
  try {
    const response =
      await apiRequest<PublicPlatformSettings>(
        "/platform-admin/settings/public/",
        {
          method: "GET",
        },
      );

    return {
      platform_name:
        response.platform_name?.trim() ||
        FALLBACK_SETTINGS.platform_name,

      support_email:
        response.support_email?.trim() ||
        FALLBACK_SETTINGS.support_email,

      support_whatsapp:
        response.support_whatsapp?.replace(
          /\D/g,
          "",
        ) ||
        FALLBACK_SETTINGS.support_whatsapp,

      support_hours:
        response.support_hours?.trim() ||
        FALLBACK_SETTINGS.support_hours,

      whatsapp_message:
        response.whatsapp_message?.trim() ||
        FALLBACK_SETTINGS.whatsapp_message,
    };
  } catch {
    return FALLBACK_SETTINGS;
  }
}
